import Item from 'common/ITEMS/Item';

/**
 * @description This file contains items that are not class specific, do not fall into the specific categories, but information is needed outside of what the log provides.
 */
const items = {
  RADIANT_JEWELBINDER: {
    id: 263897,
    name: 'Radiant Jewelbinder',
    icon: 'inv_10_misc_winterpeltfurbolg_toy',
  },
} satisfies Record<string, Item>;

export default items;
